<template>
  <div class="title">
    <span
      v-if="categoryIcon"
      class="title__icon icon">
      <icon-font
        :name="categoryIcon"
        class="icon__char"
      />
      <span
        v-if="hasAlertedChild"
        class="icon__alert"
      />
    </span>
    <span
      v-else
      class="title__icon-placeholder"
    />
    <span class="title__title">{{ title }}</span>
    <div class="title__action">
      <slot name="action"/>
    </div>
  </div>
</template>

<script>
import IconFont from '@/mikan/_shared/components/atoms/icons/IconFont.vue';

export default {
  components: {
    IconFont,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    categoryIcon: {
      type: String,
      default: '',
    },
    hasAlertedChild: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';

.title {
  $icon-size: 1.33em;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1em;
  color: $color-text-base;
  font-weight: bold;
  transition: color $transition-base;

  &:hover {
    color: $color-text-link;
  }

  &__icon {
    flex: 0 0 auto;
    font-size: $icon-size;
  }

  &__icon-placeholder {
    width: $icon-size;
    height: $icon-size;
    flex-shrink: 0;
  }

  &__title {
    flex: 1 0 auto;

    &:nth-child(n + 2) {
      margin-left: 1em;
    }
  }

  &__action {
    display: flex;
    height: 1.33em;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    font-size: 1.33em;
    grid-area: action;
  }
}

.icon {
  position: relative;
  color: $color-orange;

  &__alert {
    position: absolute;
    top: 0;
    right: 0;
    width: 7px;
    height: 7px;
    background-color: $color-strawberry;
    border-radius: 50%;
    transform: translate(50%, -50%);
  }
}
</style>
